import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ScrollNavigation from 'containers/Product/ScrollNavigation/index'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

const Navigation = props => {
  return (
    <div styleName='scrollNavigation'>
      <ScrollNavigation {...props}/>
    </div>
  )
}

export default CSSModules(styles, Navigation)
